exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2DsF1{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1ZRr7{text-align:center;vertical-align:middle;overflow:hidden;-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto}.Hx99o{position:absolute;height:100%;width:100%;top:0;left:0}.aAniA{position:relative;padding:10px 0 15px;height:100%}._2_yhd{position:absolute;top:0;left:0;right:0;width:100%;height:100%;color:#fff;padding:10px;background:#0004}._1ZRr7:hover+._2_yhd{opacity:0}", ""]);

// exports
exports.locals = {
	"advert": "_2DsF1",
	"thumb": "_1ZRr7",
	"link": "Hx99o",
	"subInfo": "aAniA",
	"brick": "_2_yhd"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/AdvertCard/AdvertCard.css
// module id = 1861
// module chunks = 0 20 24 33 36